import { useEffect, useState } from "react";

import sdk from "@farcaster/miniapp-sdk";
import { useAccount, useConnect } from "wagmi";
import { useWhitelistMint } from "@/hooks/useWhitelistMint";
import { useTotalSupply } from "@/hooks/useTotalSupply";

import { MINTED_SHARE_TEXT } from "@/constants/share";
import { MINIAPP_SHARE_URL } from "@/constants/url";
import { TOTAL_MINT } from "@/constants/mint";

import "swiper/css";
import "swiper/css/effect-cards";
import toast from "react-hot-toast";
import style from "./style.module.scss";
import { motion, AnimatePresence } from "motion/react";

function toNumber(value?: bigint): number {
  return value !== undefined ? Number(value) : 0;
}

const MintView = () => {
  const { isConnected } = useAccount();
  const { connect, connectors } = useConnect();

  const { isSuccess, handleMint } = useWhitelistMint();
  const totalSupply = useTotalSupply();

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const closeModal = () => setShowSuccessModal(false);

  useEffect(() => {
    if (isSuccess) {
      setShowSuccessModal(true);
    }
  }, [isSuccess]);

  const handleClickMint = async () => {
    if (!isConnected) connect({ connector: connectors[0] });
    else {
      try {
        await handleMint();
      } catch (err) {
        console.error("Failed to mint NFT:", err);
        toast.error("Failed to mint NFT. Please refresh and try again.", {
          duration: 3000,
        });
      }
    }
  };

  const handleShare = async () => {
    await sdk.actions.composeCast({
      text: MINTED_SHARE_TEXT,
      embeds: [MINIAPP_SHARE_URL],
    });
  };

  return (
    <div className={style.wrapper}>
      <div className={style.background}>
        <img src="/images/mint-bg.png" alt="" />
      </div>
      <div className={style.nftImage}>
        <img src="/images/nft-blind.png" />
      </div>

      <ul className={style.list}>
        <li className={style.item}>Mint Price: Free Mint</li>
        <li className={style.item}>Mint Limit: 1 per wallet</li>
        <li className={style.item}>Minting Method: FCFS WL</li>
        <li className={style.item}>Collection Size: {TOTAL_MINT} unique</li>
      </ul>

      <p className={style.mintCount}>
        Minted: {toNumber(totalSupply)}/{TOTAL_MINT}
      </p>
      <button
        className={`${style.mintButton} button-flat`}
        onClick={handleClickMint}
      >
        Mint
      </button>

      <AnimatePresence>
        {showSuccessModal && (
          <>
            <motion.div
              className={style.modalOverlay}
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.7 }}
              exit={{ opacity: 0 }}
              onClick={closeModal}
            />

            <motion.div
              className={style.modal}
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.85 }}
              transition={{ duration: 0.25 }}
            >
              <h2>Mint successful!</h2>
              <p>
                You now own one of the {TOTAL_MINT} unique Warplet Mutants
                variants
              </p>

              <div className={style.buttonWrapper}>
                <button
                  className="button-flat"
                  style={{ borderRadius: "4px", width: "100%" }}
                  onClick={handleShare}
                >
                  Share
                </button>
                <button
                  className="button-flat"
                  style={{ borderRadius: "4px", width: "100%" }}
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MintView;
